<template>
    <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

        <b-form @submit.prevent="save">
            <b-card>
                <b-form-row>
                    <b-col lg="12" sm="12" class="text-left">
                        <Lg-finder-page-usuario :disabled="isVisualizar" :prefix="prefix + title + ' > '"
                            id="finderusuario" @onselect="handleUsuarioSelect" v-model="form.usuario"
                            invalidFeedback="Usuário deve ser informada!" label="Usuario:*">
                        </Lg-finder-page-usuario>
                    </b-col>

                    <b-col lg="12" sm="12" class="text-left">
                        <lg-finder-page-departamento-sgu :prefix="prefix + title + ' > '"
                            id="finderUnidadeAdministrativa" :disabled="isVisualizar || id != null"
                            @onselect="handleSelectUnidadeAdministrativa" v-model="form.departamento"
                            invalidFeedback="Informe uma unidade administrativa!" label="Unidade Administrativa:*">
                        </lg-finder-page-departamento-sgu>
                    </b-col>

                    <b-col lg="12" sm="12" class="text-left">
                        <lg-finder-page-modulo id="finderModulo" :prefix="prefix + title + ' > '"
                            @onselect="handleSelectModulo" v-model="form.modulo"
                            :disabled="isVisualizar || !form.departamento.id" invalidFeedback="Informe um modulo!"
                            label="Modulo:*">
                        </lg-finder-page-modulo>
                    </b-col>

                    <b-col lg="12" sm="12" class="text-left">
                        <lg-finder-page-perfil id="finderPerfil" :prefix="prefix + title + ' > '"
                            @onselect="handleSelectPerfil" v-model="form.perfil"
                            :disabled="isVisualizar || !form.departamento.id" invalidFeedback="Informe um perfil!"
                            label="Perfil:*">
                        </lg-finder-page-perfil>
                    </b-col>


                    <lg-form-input v-if="isVisualizar" disabled lg="12" sm="12" v-model="form.dataCriacaoPerfilUsuario"
                        description=" " label="Data Criação:" placeholder="" />

                    <lg-form-input v-if="isVisualizar" disabled lg="12" sm="12" v-model="form.respCriacaoPerfilUsuario"
                        description=" " label="Responsável Criação:" placeholder="" />


                    <lg-form-input v-if="isVisualizar" disabled lg="12" sm="12" v-model="form.dataAtualPerfilUsuario"
                        description=" " label="Data Alteração:" placeholder="" />

                    <lg-form-input v-if="isVisualizar" disabled lg="12" sm="12" v-model="form.respAtualPerfilUsuario"
                        description=" " label="Responsável Alteração:" placeholder="" />


                </b-form-row>

                <b-form-row>

                    <b-col cols="3"></b-col>
                    <b-col cols="6" class="text-center">
                        <b-button id="salvar" class=" my-2" size="sm" pill variant="success" @click="save">
                            <b-icon icon="check-circle" />
                            <b-tooltip target="salvar" title="Salvar"></b-tooltip>

                        </b-button>

                        <b-button id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger" @click="cancelar">
                            <b-icon icon="x-circle" />
                            <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>

                        </b-button>
                    </b-col>
                    <b-col cols="3"></b-col>

                </b-form-row>

            </b-card>
        </b-form>
    </b-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import LgFinderPageUsuario from "@/components/Finders/LgFinderPageUsuario.vue";
import LgFinderPagePerfil from "@/components/Finders/LgFinderPagePerfil.vue";
import LgFinderPageDepartamentoSgu from "@/components/Finders/LgFinderPageDepartamentoSgu.vue";
import LgFinderPageModulo from "@/components/Finders/LgFinderPageModulo.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";


export default {
    name: "associacao-perfil-usuario",

    components: {
        LgFinderPageUsuario,
        LgFinderPagePerfil,
        LgFinderPageDepartamentoSgu,
        LgFinderPageModulo,
        LgFormInput
    },

    props: {
        id: Number,
        prefix: {
            type: String,
            default: "",
        },
        isVisualizar: {
            type: Boolean,
            default: false,
        }
    },


    mixins: [ListResourceMixin, FormResourceMixin],
    validations: {
        form: {
            usuario: { id: { required } },
            departamento: { id: { required } },
            modulo: { id: { required } },
            perfil: { id: { required } },
        },
    },
    data() {
        return {
            title: " Cadastro",
            showModal: true,
            form: {
                perfil: {
                    id: undefined,
                    perfil: "",

                },
                usuario: {
                    id: undefined,
                    nome: "",
                },
                modulo: {
                    id: undefined,
                    descricao: "",

                },
                usuarioResponsavel: {
                    id: undefined,
                    nome: "",

                },
                departamento: {
                    id: undefined,
                    nome: "",

                },
                dataCriacaoPerfilUsuario: "",
                respCriacaoPerfilUsuario: "",
                dataAtualPerfilUsuario: "",
                respAtualPerfilUsuario: "",
            },
        };
    },

    async beforeMount() {
        this.$service = new ResourceService(`/api/sgu/usuarios/${0}/perfis`);
        const brand = JSON.parse(localStorage.getItem("context"))


        if (this.id) {
            const { data } = await this.$service.findById(this.id);
            this.form.id = this.id;
            this.form.usuario.id = data.usuario.id;
            this.form.usuario.nome = data.usuario.nome;

            this.form.departamento.id = data.departamento.id;
            this.form.departamento.nome = data.departamento.nome;

            this.form.modulo.id = data.modulo.id;
            this.form.modulo.descricao = data.modulo.descricao;

            this.form.perfil.id = data.perfil.id;
            this.form.perfil.perfil = data.perfil.perfil;

            this.form.usuarioResponsavel.id = data.usuarioResponsavel.id;
            this.form.usuarioResponsavel.nome = data.usuarioResponsavel.nome;

            this.form.dataCriacaoPerfilUsuario = new Date(data.dataCriacaoPerfilUsuario).toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            });
            this.form.respCriacaoPerfilUsuario = data.respCriacaoPerfilUsuario;

            this.form.dataAtualPerfilUsuario = new Date(data.dataAtualPerfilUsuario).toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            });


            this.form.respAtualPerfilUsuario = data.respAtualPerfilUsuario;



        }
        this.form.usuarioResponsavel = brand.usuario;



    },

    watch: {
        page() {
            this.load();
        },

    },

    methods: {

        cancelar() {
            this.$emit("close");
        },
        async handleUsuarioSelect(item) {
            this.form.usuario = item;
            this.handleSelectUnidadeAdministrativa(item.codDepartamentoSgu);
        },

        async handleSelectUnidadeAdministrativa(item) {

            this.form.departamento = item;

        },
        async handleSelectModulo(item) {
            this.form.modulo = item;
        },
        async handleSelectPerfil(item) {
            this.form.perfil = item;
        },

        async handleSelectPageUsuario(usuariopage) {
            this.form.usuariopage = usuariopage;
        },

        async save() {
            if (!this.formIsValid) {
                this.$v.$touch();

                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                });
                return;
            }
            try {
                await this.$service.save(this.form);
                this.$notify({
                    type: "success",
                    message: 'Registro salvo com sucesso'
                });
                this.cancelar();

            } catch (e) {
                this.$notify({
                    type: "danger",
                    message: 'Este registro já está cadastrado'
                });
                return;
            }

        },
    },
};
</script>
